const assetVersion = encodeURIComponent(__BREACHER_ASSET_VERSION__);

export function assetURL(path: string): string {
  return `${path}?v=${assetVersion}`;
}

export const CORE_ATLAS_JSON = `/assets/atlases/core.json?v=${assetVersion}`;
export const CORE_ATLAS_IMAGE = `/assets/atlases/core.png?v=${assetVersion}`;
